import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; // Lisää tämä
import axios from 'axios';
import ChatWindow from './ChatWindow';

const Index = () => {
    const { userId: paramUserId } = useParams(); // Hae userId URL:sta
    const [userData, setUserData] = useState({});
    const [answers, setAnswers] = useState({});

    useEffect(() => {
        if (paramUserId) {
            setUserData({ userId: paramUserId });
        }
    }, [paramUserId]);

    useEffect(() => {
        if (userData.userId) {
            const intervalId = setInterval(() => {
                axios.post(process.env.REACT_APP_API_URL + '/api/heartbeat', { userId: userData.userId })
                    .then(() => console.log('Heartbeat sent'))
                    .catch((error) => console.error('Error sending heartbeat:', error));
            }, 300000); // Lähettää heartbeatin 5 minuutin välein

            return () => clearInterval(intervalId);
        }
    }, [userData.userId]);

    return (
        <div className="chat-window">
            <ChatWindow
                userData={userData}
                setUserData={setUserData}
                answers={answers}
                setAnswers={setAnswers}
            />
        </div>
    );
};

export default Index;
